export default {
  wellsSelected: [],
  wellSelected: null,
};
